import { render, staticRenderFns } from "./change-email.vue?vue&type=template&id=5cf7b05d"
import script from "./change-email.vue?vue&type=script&lang=js"
export * from "./change-email.vue?vue&type=script&lang=js"
import style0 from "./change-email.vue?vue&type=style&index=0&id=5cf7b05d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports